export const actionTypes = {
  FAILED: 'log-sync-merchant/failed',
  LOADING: 'log-sync-merchant/loading',
  SUCCESS: 'log-sync-merchant/success',
  FILTER: 'log-sync-merchant/filter',
  MESSAGE: 'log-sync-merchant/message',
};
